<template>
  <div class="prize-modal-option flex gap-100 mb-200 flex-shrink-0" v-drag-scroll>
    <HighFrequencyGameOptionBadge v-if="prizeTier?.spots">
      {{ $t('highfrequencygame.prizemodaloptions.spots') }}
      <template #value>{{ prizeTier.spots }}</template>
    </HighFrequencyGameOptionBadge>

    <HighFrequencyGameOptionBadge v-if="prizeTier?.wager">
      {{ $t('highfrequencygame.prizemodaloptions.wager') }}
      <template #value>
        {{ formatMoney(prizeTier.wager, { fractionDigits: 0 }) }}
      </template>
    </HighFrequencyGameOptionBadge>

    <HighFrequencyGameOptionBadge v-for="addOn in activeAddOns" :key="addOn">
      {{ $t(`highfrequencygame.addon.${addOn}`) }}
      <template #outer-value>
        <LcImage class="w-300 h-300" v-bind="getImage(addOn)!" alt="" />
      </template>
    </HighFrequencyGameOptionBadge>
  </div>
</template>

<script lang="ts" setup>
import { getHfgAddOnIllustration } from './highFrequencyGameConstants'

const { getIllustrationMini } = useAsset()
const { addOns, prizeTier, selectedAddOns } = useHighFrequencyGame()

const activeAddOns = computed(() =>
  addOns.value.filter((addOn) => selectedAddOns.value.includes(addOn)),
)

const getImage = (addOnName: string) =>
  getIllustrationMini(getHfgAddOnIllustration(addOnName) ?? 'rocket-active')
</script>

<style lang="scss" scoped>
.prize-modal-option {
  white-space: nowrap;
}
</style>
